import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

import Spinner from '@components/spinner'
import Error from '@components/Error/NoContent'
import RevenuesTable from './RevenuesTable'
import Scroll from '@components/Scroll'
import { getMonthFullName, getYear, formatNumber } from '@atheneum/api/dist/lib'
import Actions from './Actions'
import RevenuesFilterPanel from './RevenuesFilterPanel'

class RevenuesView extends Component {
  static propTypes = {
    revenuesStore: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.loadInitialData()
  }

  loadInitialData() {
    this.props.revenuesStore.filterResults()
  }

  renderError(error) {
    if (error) return <Error />
  }

  renderLoader() {
    return <Spinner />
  }

  render() {
    const { loading, error, revenues, query } = this.props.revenuesStore
    if (error) {
      return this.renderError(error)
    }
    if (loading) {
      return this.renderLoader()
    }

    let revenueSum = 0
    let honSum = 0
    let costSum = 0
    let marginSum = 0
    revenues.map(res => {
      revenueSum = revenueSum + res.rev
      honSum = honSum + res.hon
      costSum = costSum + res.cost
      marginSum = marginSum + res.margin
    })
    return (
      <div className='revenues-view'>
        <Scroll>
          <div style={{ overflowX: 'auto', height: 'calc(100vh - 75px)' }}>
            <div
              className='project-wrapper'
              style={{
                minWidth: '1450px',
                paddingLeft: 25,
                paddingRight: 25
              }}
            >
              <div className='details-header'>
                <div className='info info--noLeft'>
                  <div className='name-status-wrapper'>
                    <h1>Revenues report</h1>
                    <h2 style={{ color: "red" }}>An <a href={process.env.REACT_APP_METABASE_REVENUE_REPORT_URL} target="_blank" rel="noopener noreferrer" style={{ color: "red" }}><u>equivalent version</u></a> of this report is now available in Metabase.  Please review it and provide feedback to the BI team if needed as, shortly, this report will change to take you directly there.</h2>
                  </div>
                </div>
                <div className='floating'>
                  <div>
                    <h1>{formatNumber(marginSum)}</h1>
                    <span>Margin</span>
                  </div>
                </div>
                <div className='floating'>
                  <div>
                    <h1>{formatNumber(costSum)}</h1>
                    <span>Cost</span>
                  </div>
                </div>
                <div className='floating'>
                  <div>
                    <h1>{formatNumber(honSum)}</h1>
                    <span>Honorarium</span>
                  </div>
                </div>
                <div className='floating'>
                  <div>
                    <h1>{formatNumber(revenueSum)}</h1>
                    <span>Revenue</span>
                  </div>
                </div>
              </div>
              <div className='invoice-wrapper animate-intro'>
                <div className='actions-wrapper clearfix'>
                  <ul className='actions left-list'>
                    <h2>
                      {revenues.length} projects active in
                      {` ${getMonthFullName(query.date)}`} {getYear(query.date)}
                    </h2>
                  </ul>
                  <Actions date={query.date} />
                </div>
              </div>
              <RevenuesFilterPanel />

              {revenues.length !== 0 ? (
                <RevenuesTable
                  revenues={revenues}
                  revenueSum={revenueSum}
                  honSum={honSum}
                  costSum={costSum}
                  marginSum={marginSum}
                />
              ) : (
                <Error
                  label={'No results match the current filter parameters'}
                />
              )}
            </div>
          </div>
        </Scroll>
      </div>
    )
  }
}

export default inject('revenuesStore')(observer(RevenuesView))
